<template>
  <div class="dialog-merchant-info-re-review-wrapper">
    <el-dialog title="复审商户资料" width="70%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <div class="dialog-upload-img">
        <div class="upload-img-form">
          <div class="upload-img-block">
            <h3>合同照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onHetongUploadSuccess"
              :on-error="onImgUploadFailed">
              <img
                :style="{ transform: `rotate(${mendianDegree})` }"
                @click="rotateImg(0)"
                v-if="hetong.url"
                :src="hetong.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(hetong.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>

          <div class="upload-img-block">
            <h3>门店照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onMendianUploadSuccess" >
              <img
                :style="{ transform: `rotate(${mendianDegree})` }"
                @click="rotateImg(1)"
                v-if="mendian.url"
                :src="mendian.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(mendian.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>

          <div class="upload-img-block">
            <h3>室内照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onShineiUploadSuccess" >
              <img
                :style="{ transform: `rotate(${shineiDegree})` }"
                @click="rotateImg(2)"
                v-if="shinei.url"
                :src="shinei.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(shinei.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>
          <div class="upload-img-block">
            <h3>收银台照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onShouyintaiUploadSuccess" >
              <img
                :style="{ transform: `rotate(${shouyintaiDegree})` }"
                @click="rotateImg(3)"
                v-if="shouyintai.url"
                :src="shouyintai.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(shouyintai.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>

          <div class="upload-img-block">
            <h3>手持身份证照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onHoldIdcardUploadSuccess" >
              <img
                :style="{ transform: `rotate(${holdIdcardDegree})` }"
                @click="rotateImg(4)"
                v-if="holdIdcard.url"
                :src="holdIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(holdIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>身份证正面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onFrontIdcardUploadSuccess" >
              <img
                :style="{ transform: `rotate(${frontIdcardDegree})` }"
                @click="rotateImg(5)"
                v-if="frontIdcard.url"
                :src="frontIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(frontIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>身份证反面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onBackIdcardUploadSuccess" >
              <img
                :style="{ transform: `rotate(${backIdcardDegree})` }"
                @click="rotateImg(6)"
                v-if="backIdcard.url"
                :src="backIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(backIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>银行卡正面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onFrontBankUploadSuccess" >
              <img
                :style="{ transform: `rotate(${frontBankDegree})` }"
                @click="rotateImg(7)"
                v-if="frontBank.url"
                :src="frontBank.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(frontBank.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>银行卡反面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: reReviewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onBackBankUploadSuccess" >
              <img
                :style="{ transform: `rotate(${backBankDegree})` }"
                @click="rotateImg(8)"
                v-if="backBank.url"
                :src="backBank.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(backBank.url)">预览</el-button>
          </div>
        </div>

        <el-form
          label-position="right"
          label-width="120px"
          ref="merchantForm"
          style="margin-top: 2rem;"
          v-model="merchantForm" >

          <el-form-item label="法人名称" prop="corpName">
            <el-input
              v-model="merchantForm.corpName"
              placeholder="请输入法人名称"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="商户名称" prop="name">
            <el-input
              v-model="merchantForm.name"
              placeholder="请输入商户名称"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="商户地址" prop="address">
            <el-input
              v-model="merchantForm.address"
              placeholder="请输入商户地址"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="开户人" prop="acctName">
            <el-input
              v-model="merchantForm.acctName"
              placeholder="请输入商户地址"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="开户账号" prop="acctNo">
            <el-input
              v-model="merchantForm.acctNo"
              placeholder="请输入商户地址"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="邮箱地址" prop="email">
            <el-input
              v-model="merchantForm.email"
              placeholder="请输入邮箱地址"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="身份证号" prop="certNo">
            <el-input
              v-model="merchantForm.certNo"
              placeholder="请输入身份证证件号"
              @keyup.enter.native="onImgUploadSubmit"></el-input>
          </el-form-item>

          <el-form-item label="身份证有效期" prop="certDate">
            <el-date-picker
              style="width: 49%"
              v-model="merchantForm.certStartDate"
              type="date"
              placeholder="有效起始日期">
            </el-date-picker>
            <el-date-picker
              style="width: 49%"
              v-model="merchantForm.certExpireDate"
              type="date"
              placeholder="有效结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="复审支付渠道" prop="reReviewChannel">
            <el-checkbox-group v-model="merchantForm.reReviewChannel">
              <el-checkbox label="jd">京东</el-checkbox>
              <el-checkbox label="sb">扫呗</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div class="submit-wrapper">
          <el-button
            type="danger"
            size="medium"
            @click="onImgUploadSubmit">保存</el-button>
          <el-button
            size="medium"
            @click="onImgUploadCancel">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="imgPreivewDialogViesible">
      <div style="display: flex; justify-content: center; align-items: center;">
        <img
          width="100%"
          :src="imgPreviewUrl"
          :style="{ transform: `rotate(${previewDegree}deg)` }"
          @click="rotateImg"
          alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import moment from 'moment'

export default {
  name: 'DialogMerchantInfoReReview',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    reReviewingMerchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imgPreivewDialogViesible: false,
      imgPreviewUrl: '',

      merchantForm: {
        email: '',
        corpName: '',
        name: '',
        address: '',
        acctName: '',
        acctNo: '',
        certNo: '',
        certStartDate: '',
        certExpireDate: '',
        reReviewChannel: []
      },
      hetong: {
        url: '',
        filename: ''
      },
      mendian: {
        url: '',
        filename: ''
      },
      shinei: {
        url: '',
        filename: ''
      },
      shouyintai: {
        url: '',
        filename: ''
      },
      holdIdcard: {
        url: '',
        filename: ''
      },
      frontIdcard: {
        url: '',
        filename: ''
      },
      backIdcard: {
        url: '',
        filename: ''
      },
      frontBank: {
        url: '',
        filename: ''
      },
      backBank: {
        url: '',
        filename: ''
      },

      previewDegree: 0,
      hetongDegree: 0,
      mendianDegree: 0,
      shineiDegree: 0,
      shouyintaiDegree: 0,
      holdIdcardDegree: 0,
      frontIdcardDegree: 0,
      backIdcardDegree: 0,
      frontBankDegree: 0,
      backBankDegree: 0
    }
  },
  methods: {
    ...mapActions('bank', [
      'reReviewMerchantInfo',
      'updateMerchantInfoWithImg',
      'getIdcardImg'
    ]),

    onDialogOpen () {
      this.getIdcardImg({
        merchantId: this.reReviewingMerchant.merchant_id
      }).then(res => {
        this.hetong.url = res.data.hetong
        this.mendian.url = res.data.mendian
        this.shinei.url = res.data.shinei
        this.shouyintai.url = res.data.shouyintai
        this.holdIdcard.url = res.data.hold_id_card
        this.frontIdcard.url = res.data.id_card_z
        this.backIdcard.url = res.data.id_card_f
        this.frontBank.url = res.data.bank_z
        this.backBank.url = res.data.bank_f
      })

      // Set form default value
      this.hetong.filename = this.reReviewingMerchant.hetong
      this.mendian.filename = this.reReviewingMerchant.mendian
      this.shinei.filename = this.reReviewingMerchant.shinei
      this.shouyintai.filename = this.reReviewingMerchant.shouyintai
      this.holdIdcard.filename = this.reReviewingMerchant.hold_id_card
      this.frontIdcard.filename = this.reReviewingMerchant.id_card_z
      this.backIdcard.filename = this.reReviewingMerchant.id_card_f
      this.frontBank.filename = this.reReviewingMerchant.bank_z
      this.backBank.filename = this.reReviewingMerchant.bank_f

      this.merchantForm.certNo = this.reReviewingMerchant.acct_cert_no
      this.merchantForm.certStartDate = this.reReviewingMerchant.cert_start_date
      this.merchantForm.certExpireDate = this.reReviewingMerchant.cert_expire_date
      this.merchantForm.corpName = this.reReviewingMerchant.corp_name
      this.merchantForm.name = this.reReviewingMerchant.name
      this.merchantForm.address = this.reReviewingMerchant.address
      this.merchantForm.acctName = this.reReviewingMerchant.acct_name
      this.merchantForm.acctNo = this.reReviewingMerchant.acct_no
      this.merchantForm.email = this.reReviewingMerchant.email

      this.merchantForm.reReviewChannel = []
      this.reReviewingMerchant.jd_review === 3 && this.merchantForm.reReviewChannel.push('jd')
      this.reReviewingMerchant.sb_review === 3 && this.merchantForm.reReviewChannel.push('sb')
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },

    rotateImg (index) {
      this.previewDegree = this.previewDegree === 270 ? 0 : this.previewDegree + 90
    },

    beforeUpload (file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error('只能上传图片格式！')
      }
      if (!isLt2M) {
        this.$message.error('上传的图像不能大于 2MB ！')
      }
      return isImg && isLt2M
    },

    onHetongUploadSuccess (res, file, fileList) {
      this.hetong.url = res.data.url
      this.hetong.filename = res.data.filename
    },
    onMendianUploadSuccess (res, file, fileList) {
      this.mendian.url = res.data.url
      this.mendian.filename = res.data.filename
    },
    onShineiUploadSuccess (res, file, fileList) {
      this.shinei.url = res.data.url
      this.shinei.filename = res.data.filename
    },
    onShouyintaiUploadSuccess (res, file, fileList) {
      this.shouyintai.url = res.data.url
      this.shouyintai.filename = res.data.filename
    },
    onHoldIdcardUploadSuccess (res, file, fileList) {
      this.holdIdcard.url = res.data.url
      this.holdIdcard.filename = res.data.filename
    },
    onFrontIdcardUploadSuccess (res, file, fileList) {
      this.frontIdcard.url = res.data.url
      this.frontIdcard.filename = res.data.filename
    },
    onBackIdcardUploadSuccess (res, file, fileList) {
      this.backIdcard.url = res.data.url
      this.backIdcard.filename = res.data.filename
    },
    onFrontBankUploadSuccess (res, file, fileList) {
      this.frontBank.url = res.data.url
      this.frontBank.filename = res.data.filename
    },
    onBackBankUploadSuccess (res, file, fileList) {
      this.backBank.url = res.data.url
      this.backBank.filename = res.data.filename
    },
    onImgPreview (url) {
      if (url === '') {
        this.$message({
          type: 'error',
          message: '请先上传图片'
        })
        return
      }
      this.imgPreviewUrl = url
      this.imgPreivewDialogViesible = true
    },
    onImgUploadFailed (err) {
      console.log(err)
      this.$message({
        type: 'error',
        message: '上传失败'
      })
    },
    onImgUploadCancel () {
      this.resetImgUploadForm()
      this.$emit('update:visible', false)
    },
    async onImgUploadSubmit () {
      // // 如果不是审核失败的就不能复审
      if (this.reReviewingMerchant.sb_review !== 3 && this.reReviewingMerchant.jd_review !== 3) {
        this.$message({
          type: 'error',
          message: '审核已通过，无需重复审核'
        })
        return
      }
      if (this.hetong.filename === '' || this.mendian.filename === '' ||
        this.shinei.filename === '' || this.shouyintai.filename === '' ||
        this.holdIdcard.filename === '' || this.frontIdcard.filename === '' ||
        this.backIdcard.filename === '' || this.frontBank.filename === '' ||
        this.backBank.filename === '') {
        this.$message({
          type: 'error',
          message: '请确保所有图片已经上传'
        })
        return
      }

      let startDate = new Date(this.merchantForm.certStartDate).getTime()
      let expireDate = new Date(this.merchantForm.certExpireDate).getTime()

      if (startDate > expireDate) {
        this.$message({
          type: 'warning',
          message: '开始时间不能大于结束时间'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: `正在上传图片，请稍等...`,
        spinner: 'el-icon-loading',
        background: 'rbga(0, 0, 0, 0.8)'
      })

      try {
        const res = await this.updateMerchantInfoWithImg({
          merchantId: this.reReviewingMerchant.merchant_id,

          // Img
          hetong: this.hetong.filename,
          shinei: this.shinei.filename,
          mendian: this.mendian.filename,
          shouyintai: this.shouyintai.filename,
          holdIdcard: this.holdIdcard.filename,
          idcardZ: this.frontIdcard.filename,
          idcardF: this.backIdcard.filename,
          bankZ: this.frontBank.filename,
          bankF: this.backBank.filename,

          // Field
          email: this.merchantForm.email,
          sbEmail: this.merchantForm.email,
          corpName: this.merchantForm.corpName,
          name: this.merchantForm.name,
          address: this.merchantForm.address,
          acctName: this.merchantForm.acctName,
          acctNo: this.merchantForm.acctNo,
          certNo: this.merchantForm.certNo,
          certStartAt: moment(this.merchantForm.certStartDate).format('YYYY-MM-DD'),
          certExpireAt: moment(this.merchantForm.certExpireDate).format('YYYY-MM-DD')
        })

        if (res.rcode === 0) {
          let sb = this.merchantForm.reReviewChannel.indexOf('sb') === -1 ? 0 : 1
          let jd = this.merchantForm.reReviewChannel.indexOf('jd') === -1 ? 0 : 1

          // Post re-review request
          const reviewRes = await this.reReviewMerchantInfo({
            merchantId: this.reReviewingMerchant.merchant_id, jd, sb
          })

          if (reviewRes.rcode === 0) {
            this.$message({
              type: 'success',
              message: '复审商户信息成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
          } else {
            this.$message({
              type: 'error',
              message: '复审商户信息失败'
            })
          }
        } else {
          console.log(res)
          this.$message({
            type: 'error',
            message: '复审商户信息失败'
          })
        }

        this.$nextTick(() => {
          loading.close()
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '复审商户信息失败'
        })

        this.$nextTick(() => {
          loading.close()
        })
      }

      this.$nextTick(() => {
        loading.close()
      })
      // ================ break ==================
    },
    resetImgUploadForm () {
      this.shinei.url = ''
      this.shinei.filename = ''
      this.mendian.url = ''
      this.mendian.filename = ''
      this.hetong.url = ''
      this.hetong.filename = ''
      this.shouyintai.url = ''
      this.shouyintai.filename = ''
    },
    getJWT () {
      const userInfo = JSON.parse(localStorage.getItem('user_info'))
      if (userInfo === null) {
        return {}
      }

      return {
        'x-access-token': userInfo.token,
        'secret': userInfo.secret
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-merchant-info-re-review-wrapper {

  .dialog-upload-img {

    .upload-img-form {
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      align-items: center;
      text-align: center;

      .upload-img-block {
        margin: 0 1.5rem;

        .img-uploader {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;

          &:hover {
            border-color: #409EFF;
          }
          .uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
          }
          img {
            width: 178px;
            height: 178px;
            display: block;
          }
        }
      }
    }

    .submit-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 18%;
      margin: 2rem auto 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/bank/DialogMerchantInfoReReview.vue